import React from 'react';
import { Icon } from '../Icon';
import { Timer } from '../Timer';
import styles from './DiscountBlock.css';

function DiscountBlock({ expiryTimestamp, isExpired, onExpirePromo }) {
    if (!expiryTimestamp || isExpired) {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <Icon name='discountTag' className={styles.icon} />
                <p className={styles.title}>Your promo code is applied!</p>
            </div>
            <div className={styles.divider} />
            <div className={styles.footer}>
                <div className={styles.code}>
                    <Icon name='checkTick' className={styles.checkIcon} />
                    <span>sep26</span>
                </div>
                <div className={styles.timer}>
                    <Timer
                        expiryTimestamp={expiryTimestamp}
                        onExpire={onExpirePromo}
                        minutesLabel='minutes'
                        secondsLabel='seconds'
                    />
                </div>
            </div>
        </div>
    );
}

export {
    DiscountBlock
};
